export const getCroppedImg = async (imageBlob, quality = 0.7) => {
  const image = await new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(imageBlob);
    img.onload = () => resolve(img);
  });

  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0);

    canvas.toBlob(
      (blob) => {
        const file = new File([blob], "cropped-compressed.jpg", { type: "image/jpeg" });
        resolve(file); // or resolve(file)
      },
      "image/jpeg",
      quality
    );
  });
};
